import { useState } from 'react'

import { useCloseModal, useConfigureModalController, useModalController } from '@/atoms'

import { useControllerData } from './useControllerData'

type ModalState = 'ready' | 'submitting'
interface ModalData {
  percentage: number
  totalOrders: number
  currentOrders: number
  wizardStep: 'warning' | 'storage-tips'
  isSimulation: boolean
}

export const modalId = 'outOfStorageSpace'

export const useController = () => useModalController<ModalData, ModalState>(modalId)

export const useConfigureController = () => {
  const close = useCloseModal()

  const { percentage, totalOrders, currentOrders, wizardStep, isSimulation } = useControllerData()

  // INITIALIZATION

  const [options] = useState(() => ({
    createInitialState: () => ({
      close,
      data: {
        percentage,
        totalOrders,
        currentOrders,
        wizardStep,
        isSimulation,
      },
    }),
  }))

  return useConfigureModalController<ModalData, ModalState>(modalId, options)
}
